import React from 'react';
import { IconSetId } from '../../../modules/constants/iconSets';

import FeatherSave from '../../../assets/img/icons/icon-set-previews/feather/save.svg?react';
import FeatherSend from '../../../assets/img/icons/icon-set-previews/feather/send.svg?react';
import FeatherDownload from '../../../assets/img/icons/icon-set-previews/feather/download.svg?react';
import FeatherCart from '../../../assets/img/icons/icon-set-previews/feather/cart.svg?react';
import FeatherImage from '../../../assets/img/icons/icon-set-previews/feather/image.svg?react';

import RemixSave from '../../../assets/img/icons/icon-set-previews/remix/save.svg?react';
import RemixSend from '../../../assets/img/icons/icon-set-previews/remix/send.svg?react';
import RemixDownload from '../../../assets/img/icons/icon-set-previews/remix/download.svg?react';
import RemixCart from '../../../assets/img/icons/icon-set-previews/remix/cart.svg?react';
import RemixImage from '../../../assets/img/icons/icon-set-previews/remix/image.svg?react';

import PhosphorSave from '../../../assets/img/icons/icon-set-previews/phosphor/save.svg?react';
import PhosphorSend from '../../../assets/img/icons/icon-set-previews/phosphor/send.svg?react';
import PhosphorDownload from '../../../assets/img/icons/icon-set-previews/phosphor/download.svg?react';
import PhosphorCart from '../../../assets/img/icons/icon-set-previews/phosphor/cart.svg?react';
import PhosphorImage from '../../../assets/img/icons/icon-set-previews/phosphor/image.svg?react';

import KhushmeenSave from '../../../assets/img/icons/icon-set-previews/khushmeen/save.svg?react';
import KhushmeenSend from '../../../assets/img/icons/icon-set-previews/khushmeen/send.svg?react';
import KhushmeenDownload from '../../../assets/img/icons/icon-set-previews/khushmeen/download.svg?react';
import KhushmeenCart from '../../../assets/img/icons/icon-set-previews/khushmeen/cart.svg?react';
import KhushmeenImage from '../../../assets/img/icons/icon-set-previews/khushmeen/image.svg?react';

type PreviewIcon = React.FC<React.SVGProps<SVGSVGElement>>;

export const ICON_SET_PREVIEWS: Record<IconSetId, PreviewIcon[]> = {
  minimal: [FeatherSave, FeatherSend, FeatherDownload, FeatherCart, FeatherImage],
  outline: [RemixSave, RemixSend, RemixDownload, RemixCart, RemixImage],
  duotone: [PhosphorSave, PhosphorSend, PhosphorDownload, PhosphorCart, PhosphorImage],
  handdrawn: [KhushmeenSave, KhushmeenSend, KhushmeenDownload, KhushmeenCart, KhushmeenImage]
};

export default ICON_SET_PREVIEWS;
